__turbopack_context__.v({
  "myTasksTable": "v2BTnW_myTasksTable",
  "myTasksTable__assignee": "v2BTnW_myTasksTable__assignee",
  "myTasksTable__assigneeCell": "v2BTnW_myTasksTable__assigneeCell",
  "myTasksTable__cellAction": "v2BTnW_myTasksTable__cellAction",
  "myTasksTable__context": "v2BTnW_myTasksTable__context",
  "myTasksTable__contextInternal": "v2BTnW_myTasksTable__contextInternal",
  "myTasksTable__contextSecondary": "v2BTnW_myTasksTable__contextSecondary",
  "myTasksTable__description": "v2BTnW_myTasksTable__description",
  "myTasksTable__dueDateCell": "v2BTnW_myTasksTable__dueDateCell",
  "myTasksTable__meterStack": "v2BTnW_myTasksTable__meterStack",
  "myTasksTable__serviceTypeCell": "v2BTnW_myTasksTable__serviceTypeCell",
  "myTasksTable__standaloneCreate": "v2BTnW_myTasksTable__standaloneCreate",
  "myTasksTable__standaloneCreateRow": "v2BTnW_myTasksTable__standaloneCreateRow",
  "myTasksTable__taskName": "v2BTnW_myTasksTable__taskName",
  "myTasksTable__taskTitle": "v2BTnW_myTasksTable__taskTitle",
  "myTasksTable__timelineAlert": "v2BTnW_myTasksTable__timelineAlert",
  "myTasksTable__utilityCell": "v2BTnW_myTasksTable__utilityCell",
});
